<div class="product_box" [routerLink]=" ['/supplies/details', singleFavorite.supply.id]">
  <div class="product_img">
    <img [src]="singleFavorite?.supply_variant?.image?.url" onerror="this.src='/assets/images/products/1.png'" />
  </div>
  <div class="product_deal_top" *ngIf="singleFavorite?.supply.j_supply_deals_supplies && singleFavorite?.supply.j_supply_deals_supplies?.length">
    <img [src]="singleFavorite?.supply.j_supply_deals_supplies[0]?.supply_deal?.image?.url"
    onerror="this.src='/assets/images/about/polygon.png'" />
  </div>
  <div class="exclusive">
    <span title="{{singleFavorite?.supply?.supply_brand?.name}}">{{singleFavorite?.supply?.supply_brand?.name}}</span>
  </div>
  <div class="box_content">
    <div class="flex_center">
    <h3 title="{{singleFavorite?.supply?.name}}"> {{singleFavorite.supply.name}} </h3>
  </div>
    <h4 *ngIf="singleFavorite?.supply?.dental_supplier?.business_name" class="company_name" title="{{singleFavorite?.supply?.dental_supplier?.business_name}}">
      {{singleFavorite?.supply?.dental_supplier?.business_name}} </h4>
    <h5>
      <span class="new_price"><span class="price_type">AUD</span>
        {{singleFavorite?.supply_variant.selling_price}} </span>
      <span class="old_price"><span class="price_type">AUD</span>
        {{singleFavorite.supply_variant.actual_price}} </span></h5>
    <div class="rating_box" *ngIf="rating">
      <ul class="star">
        <li *ngIf="rating >= 1">
          <i class="fa fa-star" aria-hidden="true"></i>
        </li>
        <li *ngIf="rating < 1"><i class="fa fa-star-o" aria-hidden="true"></i></li>
        <li *ngIf="rating >= 2">
          <i class="fa fa-star" aria-hidden="true"></i>
        </li>
        <li *ngIf="rating < 2"><i class="fa fa-star-o" aria-hidden="true"></i></li>
        <li *ngIf="rating >= 3"><i class="fa fa-star" aria-hidden="true"></i> </li>
        <li *ngIf="rating < 3"><i class="fa fa-star-o" aria-hidden="true"></i></li>

        <li *ngIf="rating >= 4"><i class="fa fa-star" aria-hidden="true"></i></li>

        <li *ngIf="rating < 4"><i class="fa fa-star-o" aria-hidden="true"></i></li>
        <li *ngIf="rating === 5"><i class="fa fa-star" aria-hidden="true"></i></li>
        <li *ngIf="rating < 5"><i class="fa fa-star-o" aria-hidden="true"></i></li>
        <li class="rating_count" *ngIf="rating"> {{rating.toFixed(1)}}</li>
        <li class="rating_count" *ngIf="!rating">0</li>
      </ul>
      <div class="main_heart">
        <div class='wish-check'>
          <button type="button" class="red-heart-btn favorite" mat-icon-button
            (click)="deleteSupplyFavorites($event)">
            <i class="material-icons">
              favorite
            </i>
            <div class="effect-group">
              <span class="effect"></span>
              <span class="effect"></span>
              <span class="effect"></span>
              <span class="effect"></span>
              <span class="effect"></span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
